namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.maximizable(true)
    @Serenity.Decorators.responsive(true)
    export class ReportViewerDialog extends Serenity.TemplatedDialog<ReportPreviewOptions>
    {
        constructor(options) {
            super(options); 

            $('#' + this.idPrefix + 'viewContainer').append(this.options.reportdata);
            
            //this.GetReport();
        }

        protected onDialogOpen() {
            super.onDialogOpen();
            this.element.width(794);

        }



        //private GetReport() {

        //    let ServiceEndpoint = "/Document/Render";
        //    let opt = this.options.getParams ? this.options.getParams() : this.options.params;
        //    let self = this;
        //    opt = opt ? $.toJSON(opt) : '';
        //    let m = this.idPrefix + 'viewContainer';
        //    $.ajax({
        //        type: "post",
        //        dataType: "html",
        //        async: false,
        //        url: ServiceEndpoint,
        //        data: { 'key': this.options.reportKey, 'opt': opt },
        //        success: function (response) {

        //            //$('#~_viewContainer').html(response);
        //            $('#'+self.idPrefix + 'viewContainer').append(response);


        //        }.bind(this),
        //        error: function (jqxhr, textStatus, error) {
        //            var err = textStatus + ", " + error;
        //            alert("Error! " + err);
        //        }

        //    });
        //}



        

        getTemplate() {
            return `<div id="~_viewContainer"></div>`;
        }

    }
}